import React, { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { useEventContext } from "../../../context";
import "./style.less";

export default ({ stream, moduleName, argument }) => {
    const { event } = useEventContext();
    const [isFullscreen, setFullscreen] = useState(false);
    const canvasRef = useRef(null);
    const isPlatform = event?.moduleMain?.frontendPage === "platform";
    const appHost = event.client.domain || document.location.hostname;
    const prefix = isPlatform ? "offline" : "mobile";
    let link = `${document.location.protocol}//${appHost}/${prefix}/${event.eventKey}`;
    if (!isPlatform) {
        if (stream) {
            link += `/${stream.streamKey}`;
        }
        if (moduleName) {
            link += `/${moduleName}`;
        }
    } else {
        if (moduleName && moduleName !== 'quiz') {
            link += `?module-active=${moduleName}`;
        }
    }

    if (argument) {
        link += link.includes('?') ? '&' : '?';
        link += argument;
    }

    useEffect(() => {
        const options = {
            margin: 0,
            width: isFullscreen ? Math.min(window.innerHeight, window.innerWidth) - 100 : 400,
        };

        QRCode.toCanvas(canvasRef.current, link, options, (error) => {
            if (error) {
                return console.error(error);
            }
        });

        const keyUpHandler = (evt) => {
            if (evt.code === 'Escape') {
                setFullscreen(false);
            }
        }

        if (isFullscreen) {
            window.addEventListener('keyup', keyUpHandler);
        }

        return () => {
            window.removeEventListener('keyup', keyUpHandler);
        }
    }, [isFullscreen]);

    return (
        <section className={"offline-qrCode-page" + (isFullscreen ? " fullscreen" : "")}>
            <canvas ref={canvasRef} onClick={() => setFullscreen(!isFullscreen)} />
            <div className={"offline-page-link"}>
                <span>Ссылка на страницу офлайн участника</span> <a href={link} target="_blank">{link}</a>
            </div>
        </section>
    )
}
